import I18n from 'i18n-js';
import React from 'react';
import MensajeRecordatorios from 'types/models/mensajes-recordatorios';
import styles from './mensaje-recordatorio-table.module.scss';
import { MensajeRecordatorioRow } from '../mensaje-recordatorio-list-row/mensaje-recordatorio-list-row';

interface MensajeRecordatorioListTableProps {
  data: MensajeRecordatorios[];
}

export const MensajeRecordatorioListTable = (props: MensajeRecordatorioListTableProps): JSX.Element => {
  const { data } = props;
  const { t } = I18n;

  return (
    <table className={styles.table_wrapper}>
      {data.length > 0 ? (
        <>
          <thead>
            <tr>
              <th>{t(`TarifasListPage.headers.name`)}</th>

              <th aria-label="Detail" />
            </tr>
          </thead>
          <tbody>
            {data.map((solicitud) => (
              <MensajeRecordatorioRow key={solicitud.id} solicitud={solicitud} />
            ))}
          </tbody>
        </>
      ) : (
        <p>{t(`TarifasListPage.headers.notResult`)}</p>
      )}
    </table>
  );
};
